export const hiringManagerLinkedInEndpoints = {
  account: '/users/hm/linkedin-account',
} as const;
